const getErrorNameFromUpdateMailDetailsRes = (resUpdateMailDetails) => {
    if (!resUpdateMailDetails.data && resUpdateMailDetails.status !== 'error') return '';

    const TOO_MANY_RECIPIENTS_ERROR = 'TooManyRecipients';
    
    // Get Error data from response
    const data = resUpdateMailDetails.data;

    // If error is too many recipients error, 
    //return const instead of dynamic error text
    const errorText = data.includes(TOO_MANY_RECIPIENTS_ERROR) ? TOO_MANY_RECIPIENTS_ERROR : data;

    return errorText;
};

export default getErrorNameFromUpdateMailDetailsRes;